import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Header from "../../components/Header";
import FormListItem from "../../components/FormListItem";
import * as AppActions from "../../actions";
import { Grid } from "semantic-ui-react";
import _ from "lodash";
const uuidv4 = require("uuid/v1");

class FormsContainer extends Component {
  constructor() {
    super();
    this.state = {
      width: 800,
      height: 182,
      lastRefresh: Date(Date.now()).toString()
    };
    this.tablet = window.innerWidth - 40 < 650 ? false : true;

    this.refreshScreen = this.refreshScreen.bind(this);
  }
  componentWillMount() {
    const { actions, sessionId, deviceId, forms, exists } = this.props;

    if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      navigator.appVersion.indexOf("Trident/") > 0
    ) {
      console.log("IE");
    } else {
      document.documentElement.style.setProperty(
        "--main-bg-color",
        window.shadeBlendConvert(0.2, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--thumb-bg-color",
        window.shadeBlendConvert(0.8, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--itemHover-bg-color",
        window.shadeBlendConvert(-0.2, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--pagesNumber-bg-color",
        window.shadeBlendConvert(0.6, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--optional-bg-color",
        window.shadeBlendConvert(0.6, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--sort-bg-color",
        window.shadeBlendConvert(0.4, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--sortSelected-bg-color",
        window.shadeBlendConvert(0.9, this.props.storeColour)
      );
    }

    if (forms.length === 0 && this.props.isConnected) {
      actions.readForms(sessionId, deviceId);
    } else {
      if (!exists) {
        actions.readForms(sessionId, deviceId);
      }
    }
  }

  refreshScreen() {
    if (this.props.isConnected) {
      this.setState({ lastRefresh: Date(Date.now()).toString() });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const different =
      this.props.forms !== nextProps.forms ||
      this.props.sort !== nextProps.sort;
    if (this.state.lastRefresh !== nextState.lastRefresh) {
      const { actions, sessionId, deviceId } = this.props;

      actions.readForms(sessionId, deviceId);
    }
    return different;
  }

  componentDidMount() {
    this.updateDimensions();
  }

  handleClick(
    form_id,
    form_title,
    icon_path,
    form_version,
    uuidx,
    approval_enabled,
    notification_id
  ) {
    let uuid = uuidv4();
    if (
      this.props.recovered_formId === form_id &&
      this.props.recovered_uuid !== ""
    ) {
      uuid = this.props.recovered_uuid;
    }
    this.props.actions.setSidebarVisibility(false);
    this.props.actions.updateFormExists(true);
    this.props.actions.updateFormTitle(
      form_title,
      form_version,
      icon_path,
      form_id,
      uuid,
      approval_enabled
    );
    let recovered = false;
    if (
      this.props.recovered_form.length !== 0 &&
      this.props.recovered_formId === form_id &&
      this.props.recovered_draft === false
    ) {
      recovered = true;
      this.props.actions.setWorkingDraft(this.props.recovered_form, "");
    } else {
      this.props.actions.setWorkingDraft([], "");
    }

    let result_id;
    this.props.history.push(
      `/form/${form_id}/${uuid}/${false}/${recovered}/${form_title}/${form_version}/${result_id}/${notification_id}/`
    );
  }

  updateDimensions() {
    let update_width = window.innerWidth;
    let update_height = window.innerHeight;
    this.setState({ width: update_width, height: update_height });
  }

  handleSort(value) {
    this.props.actions.sortForms(value);
  }

  getForms() {
    const { sort } = this.props;

    var forms = [];
    let orderBy = "asc";
    var formsOrdered = [];

    if (sort === "date_added") {
      formsOrdered = _.sortBy(this.props.forms, function(sort) {
        return new Date(sort);
      }).reverse();
    } else {
      formsOrdered = _.sortBy(
        this.props.forms,
        [form => form.form_title.toLowerCase()],
        [orderBy]
      );
    }

    formsOrdered.forEach((form, index) => {
      forms.push(
        <FormListItem
          container="Forms"
          onClick={this.handleClick.bind(this)}
          {...form}
          key={index}
        />
      );
    });

    return (
      <Grid columns={6} doubling>
        <Grid.Row>{forms}</Grid.Row>
      </Grid>
    );
  }
  render() {
    let y = this.state.height - 50 + "px";

    const { actions, sort } = this.props;
    return (
      <div>
        <Header
          formTitle={"Forms"}
          onRefresh={this.refreshScreen}
          sort={sort}
          onSort={this.handleSort.bind(this)}
          setSidebarVisibility={actions.setSidebarVisibility}
        ></Header>

        <div
          className="formsBackground"
          style={{
            height: y,
            paddingBottom: "102px",
            overflowY: "scroll",
            "-webkit-overflow-scrolling": "touch"
          }}
        >
          <div className="formSectionContainerX">
            <form
              className="ui formList"
              style={{ padding: this.tablet ? "60px" : "30px" }}
            >
              {this.getForms()}
            </form>
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}

FormsContainer.propTypes = {
  sessionId: PropTypes.string.isRequired,
  forms: PropTypes.array.isRequired,
  sort: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired,
  storeColour: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  sessionId: state.informedWebApp.sessionId,
  deviceId: state.informedWebApp.deviceId,
  isLoading: state.informedWebApp.isLoading,
  storeColour: state.informedWebApp.storeColour,
  isConnected: state.informedWebApp.isConnected,
  forms: state.forms.data,
  exists: state.form.exists,
  recovered_form: state.forms.recovered_form,
  recovered_formId: state.forms.recovered_formId,
  recovered_uuid: state.forms.recovered_uuid,
  recovered_draft: state.forms.recovered_draft,
  sort: state.forms.sort
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FormsContainer)
);



// WEBPACK FOOTER //
// ./src/containers/FormsContainer/index.js